import { atom } from 'jotai';

import {
  type ExtractedField,
  type PageDimensionsByPage,
  type TemplateResponse,
} from '../../contracts';
import { DEFAULT_PAGE_DIMENSIONS_BY_PAGE } from '../pdf-fields';
import { ModalType } from './pdf-loading-modal.enums';
import { type FormViewType } from './view-form-modal.types';

type FormFillingData = {
  file: File;
  url: string;
};

export const chooseTemplateTypeModalOpenAtom = atom<boolean>(false);
export const formFillingUploadModalOpenAtom = atom<boolean>(false);

export const formViewModalOpenAtom = atom<boolean>(false);
export const formTemplateToEditAtom = atom<TemplateResponse | null>(null);
export const formViewTypeAtom = atom<FormViewType | null>(null);
export const formDraftTitleAtom = atom<string>('');

export const formFillingDataAtom = atom<FormFillingData | null>(null);

export const pdfLoadingModalTypeAtom = atom<ModalType>(ModalType.PREPARING);
export const pdfLoadingModalOpenAtom = atom<boolean>(false);

export const newlyCreatedTemplateAtom = atom<{ id: string; name: string } | null>(null);

export const formFieldsToSaveAtom = atom<ExtractedField[]>([]);
export const formFieldsEditedAtom = atom<boolean>(false);
export const formFieldsPageDimensionsAtom = atom<PageDimensionsByPage>(
  DEFAULT_PAGE_DIMENSIONS_BY_PAGE
);
export const resetFormFieldSaveStateAtom = atom(null, (_get, set) => {
  set(formFieldsToSaveAtom, []);
  set(formFieldsEditedAtom, false);
  set(formFieldsPageDimensionsAtom, DEFAULT_PAGE_DIMENSIONS_BY_PAGE);
});

/**
 * XML form review step (XML-MVP). XML never enters `/scribe/form-editor` — the
 * editor is a PDF canvas and has no page to lay fields out on — so the upload
 * modal hands the file to its own review modal instead.
 */
export const xmlFormReviewModalOpenAtom = atom<boolean>(false);
export const xmlFormReviewFileAtom = atom<File | null>(null);

/**
 * JSON form review. Same split as XML: the upload modal hands the file to
 * review. Stays closed while `release-growth-enable-json-form` is off.
 */
export const jsonFormReviewModalOpenAtom = atom<boolean>(false);
export const jsonFormReviewFileAtom = atom<File | null>(null);

/** Route to return to after leaving `/scribe/form-editor` (set before navigating in). */
export const formEditorReturnPathAtom = atom<string | null>(null);
